import { render, staticRenderFns } from "./TextStrikethroughIcon.vue?vue&type=template&id=315305e7&"
import script from "./TextStrikethroughIcon.vue?vue&type=script&lang=js&"
export * from "./TextStrikethroughIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports